<template>
  <RegCovid />
  <footer>
    <div class="footer-map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d771.821389711323!2d130.1861785274374!3d32.4537477151722!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x353feefffe61553f%3A0xd225c2d105fb6b64!2z6ZW35LqV5ZWG5LqL5qCq5byP5Lya56S-5pys5rih5bu65p2Q6YOo!5e0!3m2!1sja!2sjp!4v1693541024925!5m2!1sja!2sjp"
        width="100%"
        height="100%"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
    <div class="footer-contents">
      <div class="footer-contents-inner">
        <div class="logo">
          <h2>
            <router-link to="/">
              <p>天草で住宅・不動産を探すなら</p>
              <img src="@/assets/images/common/logo.svg" alt="ナガイホーム" />
            </router-link>
          </h2>
        </div>
        <div class="right">
          <ul class="footer-list">
            <li>
              <h3>長井商事株式会社不動産部</h3>
              <p class="address">熊本県天草市古川町10-20</p>
            </li>
            <li>
              <p class="tel">
                <a href="tel:0969237101">
                  <svg
                    version="1.1"
                    id="tel"
                    x="0px"
                    y="0px"
                    viewBox="0 0 22.5 29.4"
                  >
                    <path
                      class="st0"
                      d="M21.5,24.4l-3-4.6c-0.2-0.3-1.6,0-2.3,0.4c-0.7,0.5-1.4,1.2-1.8,2c-0.7,0.4-1.2,0-2.3-0.5
	C10.6,21,9,19,7.7,17.2c-1.1-1.9-2.3-4.2-2.4-5.7c0-1.3-0.1-1.9,0.5-2.4C6.8,9,7.6,8.7,8.4,8.3c0.7-0.5,1.5-1.6,1.3-2l-3-4.6L5.6,0
	C4.4,0.2,3.1,0.6,2,1.2C0,2.6-0.4,6.7,0.4,10c0.8,3.3,2.1,6.5,4,9.4c1.9,2.8,4.2,5.4,6.9,7.5c2.7,2.1,6.6,3.4,8.7,2.1
	c1-0.8,1.9-1.7,2.6-2.8L21.5,24.4z"
                    />
                  </svg>
                  0969-23-7101
                </a>
              </p>
              <p class="opentime">受付時間 10:00~17:00</p>
            </li>
            <li>
              <p class="license">
                <span>熊本県知事許可⑴第5247号／</span>
                <span>（一社）熊本県宅地建物取引業協会会員</span>
              </p>
            </li>
          </ul>
          <div class="banner">
            <a href="https://www.instagram.com/nagai.home/" target="_blank">
              <img src="@/assets/images/common/banner_insta.jpg" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <nav class="gnav">
      <div class="gnav-inner">
        <h3>
          <a href="https://nagaitrading.co.jp">
            <img
              src="@/assets/images/common/logo_hrz.svg"
              alt="長井商事株式会社"
            />
          </a>
        </h3>
        <ul>
          <li>
            <a
              href="https://nagaitrading.co.jp"
              target="_blank"
              rel="noopener noreferrer"
            >
              長井商事株式会社トップ
            </a>
          </li>
          <li>
            <a
              href="https://nagaitrading.co.jp/ourbiz.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              事業内容
            </a>
          </li>
          <li>
            <a
              href="https://nagaitrading.co.jp/philosophy.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              企業理念
            </a>
          </li>
          <li>
            <a
              href="https://nagaitrading.co.jp/company.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              会社概要
            </a>
          </li>
          <li>
            <a
              href="https://nagaitrading.co.jp/office.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              事業所のご案内
            </a>
          </li>
        </ul>
      </div>
    </nav>
    <p class="copyright">© 2022 Nagai Trading Co.,Ltd.</p>
  </footer>
</template>

<script>
import RegCovid from "@/components/PartsRegCovid.vue";
export default {
  components: {
    RegCovid,
  },
};
</script>

<style scoped lang="scss">
footer {
  width: 100%;
  background-color: white;
  border-top: 1px solid $color_lblue;

  .footer-map {
    width: 100%;
    height: 30vmax;
  }
  .footer-contents {
    padding: 2em $h-gap;
    .footer-contents-inner {
      max-width: 1280px;
      margin: 0 auto;
      display: flex;
      gap: $h-gap;
      @include sp {
        display: block;
      }
      .logo {
        align-self: center;
        max-width: 200px;
        min-width: 180px;
        transition: 0.2s;
        &:hover {
          opacity: 0.8;
        }
        p {
          font-size: 0.7rem;
          text-align: center;
          margin-bottom: 0.5em;
        }
        @include sp {
          margin-bottom: 2rem;
          p {
            text-align: left;
          }
        }
        img {
          width: 100%;
          height: auto;
        }
      }
      .right {
        display: flex;
        gap: 2rem;
        @include tb {
          display: block;
        }
        .footer-list {
          display: grid;
          flex-basis: 60%;
          grid-gap: 0.5rem;
          line-height: 1.5;
          flex-shrink: 1;
          flex-grow: 3;
          h3 {
            font-weight: bold;
            display: inline-block;
            margin-right: 1rem;
          }

          .address {
            display: inline-block;
          }
          .tel {
            @include din;
            color: $color_blue;
            font-size: 2.5rem;
            font-weight: bold;
            margin-right: 1rem;
            position: relative;
            a {
              display: inline-flex;
              text-decoration: none;
              color: inherit;
              padding: 0;
            }
            svg {
              align-self: center;
              position: relative;
              height: 0.8em;
              width: 1em;
              object-fit: contain;
              fill: $color_blue;
            }
          }
          .opentime {
            font-size: 1rem;
            display: inline-block;
          }
          .license {
            color: $fontcolor_sub;
            font-size: 0.8em;
            span {
              display: inline-block;
            }
          }
        }
        .banner {
          align-self: center;
          flex-basis: 480px;
          flex-shrink: 2;
          min-width: 240px;
          @include tb {
            width: 100%;
            margin-top: 1rem;
          }
          img {
            outline: 1px solid $color_sub;
            transition: 0.2s;
            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }
  }
}
.gnav {
  background-color: $color_lblue;
  padding: 2em $h-gap;

  .gnav-inner {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    gap: $h-gap;
    align-items: center;
    h3 {
      width: 180px;
      img {
        width: 100%;
        height: auto;
      }
    }
    ul {
      color: $color_blue;
      text-decoration: underline;
      display: flex;
      flex-wrap: wrap;
      gap: 1em 2em;
    }
  }
}
.copyright {
  background-color: $color-blue;
  font-size: 0.8rem;
  color: white;
  text-align: center;
  padding: 1em $h-gap 4em $h-gap;
}
</style>
